import { memo } from "react";

import { Switch } from "@synthesis/shared-ui";

import { useApplicationNotifications } from "../use-application-notifications";

export const NotificationsEmailSwitch = memo(() => {
  const { email, setEmailChecked } = useApplicationNotifications();

  return <Switch checked={email.isChecked} label="Уведомлять на почту" onCheckedChange={setEmailChecked} />;
});

NotificationsEmailSwitch.displayName = "NotificationsEmailSwitch";
